export class VendSize {
    ID?: number;
    Name?: string;
    Inactive: boolean;
}

export default VendSize;